import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import PlainTextAreaComponent from '../../../../../Ui/Common/PlainTextAreaComponent';
/**
 * セミナーのテキストエリアコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormTextareaField = (props) => {
    const { className, disabled, input, inputClassName, meta } = props;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsx("div", Object.assign({ className: 'client_seminar_one_form_textarea' }, { children: _jsx("div", Object.assign({ className: 'textarea_inner field' }, { children: _jsx(PlainTextAreaComponent, { autosized: true, className: clsx('input-form-textarea textarea_input', inputClassName), disabled: disabled, input: input, maxLength: 5000, meta: meta, placeholder: '' }) })) })) })));
};
SeminarOneFormTextareaField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    input: propShape().isRequired,
    inputClassName: propStr(),
    meta: propShape().isRequired,
};
SeminarOneFormTextareaField.defaultProps = {
    className: '',
    disabled: false,
    inputClassName: '',
};
export default SeminarOneFormTextareaField;
